<div>
  <p-fieldset legend="Lägg till medlemskap">
    <form [formGroup]="addmembershipform">
      <div class="row">
        <div class="form-group col-md-12">
          <label>Medlem</label>
          <div>{{memberid}} {{givenname}} {{familyname}}</div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-8">
          <label for="startCauseId">Institution</label>
          <select class="form-control form-control-sm" id="institutionId" formControlName="institutionId" required>
            <option></option>
            <option *ngFor="let i of institutions" [ngValue]="i.id">{{i.shortName}} {{i.name}}</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="startDate">Från datum</label>
          <app-calendar [form]="addmembershipform" formName="startDate" [required]=true></app-calendar>
        </div>
      </div>
    </form>
    <br>
    <div class="col-md-12">
      <div class="row">
        <div>
          <button class="btn border" (click)="save()" [disabled]="!addmembershipform.valid">Spara</button>
        </div>
        <div style="margin-left:20px;">
          <button class="btn border" (click)="close()">Avbryt</button>
        </div>
      </div>
    </div>
  </p-fieldset>
</div>